import { render, staticRenderFns } from "./FeederDetail.vue?vue&type=template&id=c06ec982"
import script from "./FeederDetail.vue?vue&type=script&lang=js"
export * from "./FeederDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QResizeObserver from 'quasar/src/components/resize-observer/QResizeObserver.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QResizeObserver,QBtn,QSeparator,QBtnToggle,QVirtualScroll,QDialog,QCard,QForm,QInput,QIcon,QPopupProxy,QDate});qInstall(component, 'directives', {ClosePopup});
